import { render, staticRenderFns } from "./EventTable.vue?vue&type=template&id=55c37857&scoped=true&"
import script from "./EventTable.vue?vue&type=script&lang=js&"
export * from "./EventTable.vue?vue&type=script&lang=js&"
import style0 from "./EventTable.vue?vue&type=style&index=0&id=55c37857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c37857",
  null
  
)

export default component.exports